import { useCallback, useState } from "react";
import profileApi from "api/profile";
import useNotify from "hooks/useNotify";
import { useTranslation } from "react-i18next";

const useAgencyState = ({ agencyId, userId }) => {
  const [t] = useTranslation();
  let defaultPagination = {
    paginate: {
      pageSize: 6,
      pageNumber: 1,
    },
  };
  const { notifyError, notifySuccess } = useNotify();

  const [initLoading, setInitLoading] = useState(false);
  const [pagination, setPagination] = useState(defaultPagination);
  const [users, setUsers] = useState({ count: 0, results: [] });

  const listAgencyTeam = useCallback(
    async (pagination = {}) => {
      try {
        setInitLoading(true);
        const agencyTeam = await profileApi.getAgencyTeamApi(pagination);
        setUsers(agencyTeam);
      } catch (err) {
        console.error(err);
        notifyError(
          err?.data?.error ?? err?.message ?? "Something went wrong!"
        );
        setUsers([]);
      } finally {
        setInitLoading(false);
      }
    },
    [agencyId, pagination]
  );

  const onHandleUserActivity = useCallback(
    async (checked, cb = () => {}) => {
      try {
        if (userId) {
          await profileApi.modifyActivityAgencyTeamMemberApi(userId);
          cb(true);
          notifySuccess(
            t("teamMemberActivityMsg", {
              isActive: checked ? "activated" : "deactivated",
            })
          );
        }
      } catch (err) {
        cb(false);
        console.error(err);
        notifyError(
          err?.data?.error ?? err?.message ?? "Something went wrong!"
        );
      }
    },
    [userId]
  );

  const resetOnUnmount = () => {
    setPagination(defaultPagination);
    setInitLoading(false);
    setUsers({ count: 0, results: [] });
  };

  return {
    setInitLoading,
    listAgencyTeam,
    totalCount: users?.count ?? 0,
    users: users?.results,
    initLoading,
    pagination,
    setPagination,
    defaultPagination,
    resetOnUnmount,
    setUsers,
    onHandleUserActivity,
  };
};

export default useAgencyState;
